import { Check, Close, ClearSharp } from '@mui/icons-material';
import { Card, Chip, Grid, IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';

import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Schema } from 'app/containers/Messaging/MessagesSettings/components/validation';
import { translations } from 'locales/i18n';
import { CreateTemplateVariable } from 'types/AppTypes';

interface Props {
  variables: CreateTemplateVariable[];
  setVariables: Function;
  i18nDictionary?: any;
  ignoreTextScope: boolean;
  handleUpdateVariables: (values: CreateTemplateVariable[]) => void;
}

export const VariableCreation = ({
  variables,
  ignoreTextScope,
  setVariables,
  handleUpdateVariables
}: Props) => {
  const { t } = useTranslation();

  const handleDeleteVariable = (index: number) => {
    const updatedVariables = [...variables];
    updatedVariables.splice(index, 1);
    handleUpdateVariables(updatedVariables);
  };

  const {
    watch,
    formState: { errors: fieldErrors },
    register
  } = useFormContext<Schema>();

  return (
    <Grid container className="template-variables-description" spacing={2}>
      {variables.map((v, index) => {
        const scope = v.scope;
        return (
          <Grid item xs={12} md={6}>
            <Card
              className="template-variables-description__variable"
              style={{ position: 'relative' }}
            >
              <IconButton
                onClick={e => handleDeleteVariable(index)}
                aria-label="delete"
                style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  padding: '8px'
                }}
              >
                <ClearSharp />
              </IconButton>
              <Grid container style={{ paddingTop: '10px' }}>
                <TextField
                  error={
                    fieldErrors?.variables
                      ? fieldErrors.variables[v.key] && Boolean(fieldErrors.variables[v.key])
                      : false
                  }
                  helperText={
                    fieldErrors?.variables ? fieldErrors?.variables[v.key]?.root?.message : ''
                  }
                  className="article-messages-settings__content__subject"
                  variant="outlined"
                  fullWidth
                  size="small"
                  label="VariableKey"
                  value={Object.keys(watch('variables')).find(key => key === v.key)}
                  onChange={e => {
                    const updatedVariables = [...variables];
                    updatedVariables[index] = { ...v, key: e.target.value };
                    handleUpdateVariables(updatedVariables);
                  }}
                />
              </Grid>
              <Grid container>
                <TextField
                  error={
                    fieldErrors?.variables
                      ? fieldErrors.variables[v.key]?.description &&
                        Boolean(fieldErrors.variables[v.key]?.description)
                      : false
                  }
                  helperText={
                    fieldErrors?.variables
                      ? fieldErrors?.variables[v.key]?.description?.message
                      : ''
                  }
                  {...register(`variables.${v.key}.description`)}
                  className="article-messages-settings__content__subject"
                  variant="outlined"
                  fullWidth
                  label="VariableDescription"
                  size="small"
                  onChange={e => {
                    const updatedVariables = [...variables];
                    updatedVariables[index] = { ...v, description: e.target.value };
                    handleUpdateVariables(updatedVariables);
                  }}
                />
              </Grid>
              <Grid
                container
                className="template-variables-description__variable__scope"
                spacing={2}
              >
                {Object.keys(scope).map(s => {
                  if (ignoreTextScope || s === 'text') {
                    return <></>;
                  }
                  return (
                    <Grid item>
                      <Chip
                        onClick={() => {
                          const updatedScope = { ...v.scope, [s]: !v.scope[s] };
                          const updatedVariables = [...variables];
                          updatedVariables[index] = { ...v, scope: updatedScope };
                          handleUpdateVariables(updatedVariables); // set updated state
                        }}
                        size="small"
                        label={t(translations.common[s]())}
                        className={clsx('template-variables-description__variable__scope__item')}
                        icon={
                          v.scope[s] ? (
                            <Check style={{ color: 'lightgreen' }} />
                          ) : (
                            <Close style={{ color: 'darkred' }} />
                          )
                        }
                        variant="outlined"
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};
